import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { getContentType, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import {
  CardSection,
  CardTitle,
  MotherStage,
  QuestionPara,
  RelatedQuestion,
} from '../../ArticlePage/RelatedArticlesNew/styled';
import { getSearchParams } from '../common';
import { fireClickedCardEvent } from '../../../Utils/useFirebase';

export default function RecentlyAskedQuestions(props) {
  const { data } = props;
  const [gridCardSignal, setGridCardSignal] = useState({
    index: '',
    show: false,
  });

  const router = useRouter();
  const getStage = (str) => str?.split('(')[1]?.split(')')[0];

  return (
    <CardSection>
      <CardTitle>Recently asked questions</CardTitle>
      {data?.map((element, index) => {
        return (
          <Link
            href={{
              pathname: element?.content?.web_url,
              query: removeDefaultParams(router.query),
            }}
            passHref
            key={index}
            locale={false}
            onClick={(e) => {
              e.preventDefault();
              setTimeout(() => {
                router.push(element?.content?.web_url + getSearchParams(), '', {
                  locale: getRouterLocale(router),
                });
              }, [200]);
            }}
          >
            <RelatedQuestion
              onClick={() => {
                fireClickedCardEvent(
                  'Recently asked questions',
                  element?.content?.message?.substring(0, 98),
                  getContentType(),
                  element?.content?.id,
                  null,
                  element?.tagData?.web_url,
                );
                setGridCardSignal({
                  index: index,
                  show: true,
                });
              }}
              key={index}
              className={gridCardSignal.index === index && 'gridcardopacity'}
            >
              <MotherStage>
                {getStage(element?.content?.propertytags?.weekPreg)}
              </MotherStage>
              <QuestionPara>{element?.content?.message}</QuestionPara>
            </RelatedQuestion>
          </Link>
        );
      })}
    </CardSection>
  );
}
